import React from 'react';

import * as styles from './styles';

interface Content<T> {
  id: T;
  content: React.ReactNode;
}

export interface CarouselProps<T> {
  currentChildId: T;
  children: Array<Content<T>>;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export class Carousel<T> extends React.Component<CarouselProps<T>> {
  private childrenRefs: Array<React.RefObject<HTMLDivElement>> = [];

  constructor(props: CarouselProps<T>) {
    super(props);
    this.childrenRefs = this.props.children.map(() => React.createRef<HTMLDivElement>());
  }

  public componentDidMount() {
    this.applyScroll();
  }

  public componentDidUpdate(prevProps: CarouselProps<T>) {
    if (prevProps.currentChildId !== this.props.currentChildId) {
      this.applyScroll();
    }
  }

  private applyScroll() {
    const index = this.props.children.findIndex((child: Content<T>) => child.id === this.props.currentChildId);

    if (index === -1) {
      throw new Error('Current child is not defined');
    }

    const childRef = this.childrenRefs[index];

    if (childRef.current) {
      setTimeout(() =>
        childRef.current?.scrollIntoView({
          inline: 'start',
          behavior: 'smooth',
        })
      );
    }
  }

  public render = () => {
    const { children } = this.props;

    return (
      <div className={styles.carousel}>
        {children.map((child, index) => (
          <div key={String(child.id)} ref={this.childrenRefs[index]} className={styles.content}>
            {child.content}
          </div>
        ))}
      </div>
    );
  };
}
